import { z } from 'zod';

export const InventoryStatus = z.enum(['draft', 'published', 'hidden', 'sold']);
export type InventoryStatus = z.infer<typeof InventoryStatus>;

const ALLOWED_TRANSITIONS: Record<InventoryStatus, readonly InventoryStatus[]> = {
  draft: ['published', 'hidden'],
  published: ['hidden', 'sold'],
  hidden: ['published', 'sold'],
  sold: ['published', 'hidden'],
};

export function canTransition(from: InventoryStatus, to: InventoryStatus): boolean {
  if (from === to) return true;
  return ALLOWED_TRANSITIONS[from].includes(to);
}

export const PUBLIC_STATUSES: readonly InventoryStatus[] = ['published', 'sold'] as const;

export const PartStatus = z.enum(['draft', 'published', 'hidden', 'out_of_stock']);
export type PartStatus = z.infer<typeof PartStatus>;

export const PART_PUBLIC_STATUSES: readonly PartStatus[] = ['published', 'out_of_stock'] as const;

// Products (general merchandise: used tires, accessories, misc goods) reuse the
// same lifecycle as parts.
export const ProductStatus = z.enum(['draft', 'published', 'hidden', 'out_of_stock']);
export type ProductStatus = z.infer<typeof ProductStatus>;

export const PRODUCT_PUBLIC_STATUSES: readonly ProductStatus[] = [
  'published',
  'out_of_stock',
] as const;

export const ProductCondition = z.enum(['new', 'used']);
export type ProductCondition = z.infer<typeof ProductCondition>;
